import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { IconCircleCheckFilled } from "@tabler/icons-react";
import BookingForm from "../config/BookingForm";
import TrustedBy from "../components/TrustedBy";
import ContactForm from "../config/ContactForm";
import FooterCertificates from "../components/FooterCertificates";
import { useLanguage } from "../config/LanguageContext"; // Assuming the context is set up

function BookDemo() {
  const { currentLanguage } = useLanguage(); // Access current language context

  const demoPageData = [
    {
      fact: {
        en: "Book a demonstration",
        fr: "Réservez une démonstration",
        de: "Buchen Sie eine Demo",
        es: "Solicite una demostración",
      },
    },
    {
      fact: {
        en: "Tell us your requirements",
        fr: "Dites-nous vos exigences",
        de: "Teilen Sie uns Ihre Anforderungen mit",
        es: "Cuéntenos sus requisitos",
      },
    },
    {
      fact: {
        en: "See how we can customise our solutions for you",
        fr: "Découvrez comment nous pouvons personnaliser nos solutions pour vous",
        de: "Sehen Sie, wie wir unsere Lösungen für Sie anpassen können",
        es: "Vea cómo podemos personalizar nuestras soluciones para usted",
      },
    },
  ];

  return (
    <>
      <Nav />
      <div className="bookdemo-container">
        <div className="bookdemo-wrapper">
          <div data-aos="fade-right" className="bookdemo-text">
            <h1 className="bookdemo-header">
              {
                {
                  en: "Talk to our sales team",
                  fr: "Parlez à notre équipe commerciale",
                  de: "Sprechen Sie mit unserem Vertriebsteam",
                  es: "Hable con nuestro equipo de ventas",
                }[currentLanguage]
              }
            </h1>
            <span className="bookdemo-subheading">
              {
                {
                  en: "Find out about our products and services",
                  fr: "Découvrez nos produits et services",
                  de: "Erfahren Sie mehr über unsere Produkte und Dienstleistungen",
                  es: "Descubra nuestros productos y servicios",
                }[currentLanguage]
              }
            </span>
            {demoPageData.map((fact, index) => (
              <p key={index} className="bookdemo-fact">
                <i>
                  <IconCircleCheckFilled size={24} />
                </i>
                {fact.fact[currentLanguage] || fact.fact.en}
              </p>
            ))}
          </div>
          <div className="book-demo-form-container">
            <BookingForm />
          </div>
        </div>
      </div>
      {/* <TrustedBy /> */}
      <div className="right-to-left-triangle-white"></div>
      <FooterCertificates />
      <Footer />
    </>
  );
}

export default BookDemo;
